import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {CheckboxQuestion, DatePicker, RadioButtonQuestion} from "../../../components/forms";
import {InlineDiv} from "../../../components";

const Container = styled.div`
  
`;

const radioButtonQuestions = [
  {id: 'q13', question: 'Did the Nursing Facility complete the comprehensive nursing assessment within 14 days of resident\'s noted change?'},
  {id: 'q14', question: 'Was the resident\'s care plan revised within 7 days of completing the reassessment?'},
  {id: 'q15', question: 'If, after 21 days, resident is not stable and continues to demonstrate evidence of status changes, was the resident referred to the appropriate state agency?'},
  {id: 'q16', question: 'Did MHA complete Level II determination within 9 working days of notification?'},
  {id: 'q17', question: 'If specialized services were required, were the specialized services provided?'},
];

const ResidentReviewForm = ({form, onChange}) => (
  <Container>
    <p>
      Required when a resident with SMI, ID, or DD experiences a significant change in condition that affects the person's 
      need for specialized services or when a significant change results in a new suspected diagnosis of SMI, ID, or DD. 
      Identify the category in which the significant change occurred. 
    </p>
    <ol start={12}>
      <li>
        <CheckboxQuestion
          question="Indicate the category of the significant change:"
          onChange={onChange('q12')}
          selected={form['q12'].value}
          showOrBeforeLastValue
          values={['SMI', 'ID', 'DD', 'Physical', 'N/A']}
          error={!form['q12'].hasError ? null : true}
          disabled={form['q12'].disabled}
          disableOthersIfValueSelected={'N/A'}
        >
          <InlineDiv>
            <DatePicker
              value={form['q12date'].value}
              onChange={onChange('q12date')}
              error={!form['q12date'].hasError ? null : true}
              disabled={form['q12date'].disabled}
            />
          </InlineDiv>
        </CheckboxQuestion>
      </li>
      {radioButtonQuestions.map(item => (
        <li key={item.id}>
          <RadioButtonQuestion
            id={item.id}
            value={form[item.id].value}
            onChange={onChange(item.id)}
            items={RadioButtonQuestion.YesNoNotApplicable}
            question={item.question}
            error={!form[item.id].hasError ? null : true}
            disabled={form[item.id].disabled}
          >
            <InlineDiv>
              <DatePicker
                value={form[`${item.id}date`].value}
                onChange={onChange(`${item.id}date`)}
                error={!form[`${item.id}date`].hasError ? null : true}
                disabled={form[`${item.id}date`].disabled}
              />
            </InlineDiv>
          </RadioButtonQuestion>
        </li>
      ))}
    </ol>
  </Container>
);

ResidentReviewForm.propTypes = {
  form: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ResidentReviewForm;



// WEBPACK FOOTER //
// ./src/modules/record/components/ResidentReviewForm.js